exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2sjm6{background-image:linear-gradient(316deg, #d4e5f2, #eee8e5)}._2sjm6 ._2Bt0y{box-shadow:2px 9px 23px 4px rgba(0,0,0,0.35);-moz-box-shadow:2px 9px 23px 4px rgba(0,0,0,0.35);-webkit-box-shadow:2px 9px 23px 4px rgba(0,0,0,0.35)}\n", ""]);

// Exports
exports.locals = {
	"previewContainer": "_2sjm6",
	"previewImageShadow": "_2Bt0y"
};